import { useCallback } from 'react';

import { TextInputProps, useInput } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { IconButton } from 'shared/mui/IconButtons';
import { GenerateTextIconStyled } from 'shared/mui/Icons';
import { Tooltip } from 'shared/mui/Tooltip/Tooltip/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { TextInput } from 'shared/react-admin/Inputs';
import { generateNameFromAlias } from 'utils/generateNameFromAlias';

export type GenerateNameInputProps = {
  aliasSource?: string;
  onGenerate?: (name: string) => void;
} & TextInputProps;

export function GenerateNameInput({
  aliasSource = 'alias',
  onGenerate,
  ...rest
}: GenerateNameInputProps): JSX.Element {
  const { field } = useInput({ source: rest.source });
  const alias = useWatch({ name: aliasSource });

  const handleClick = useCallback(() => {
    const generatedName = generateNameFromAlias(alias);

    field.onChange(generatedName);
    onGenerate?.(generatedName);
  }, [alias, onGenerate]);

  return (
    <TextInput
      {...rest}
      InputProps={{
        endAdornment: (
          <Tooltip title={<Typography fontSize={12}>Сгенерировать название</Typography>}>
            <span>
              <IconButton disabled={!alias} onClick={handleClick}>
                <GenerateTextIconStyled disabled={!alias} />
              </IconButton>
            </span>
          </Tooltip>
        ),
      }}
    />
  );
}
